import { pantryColors } from '@pantry/ui'
import React from 'react'
import type { LoyaltyMemberStatus } from '../../../../types/loyalty'

const p = pantryColors

interface StatusDotProps {
  status: LoyaltyMemberStatus | null | undefined
}

const STATUS_COLOR: Record<LoyaltyMemberStatus, string> = {
  active: '#059669', // emerald — keep literal; not in pantryColors
  inactive: p.gray[300],
}

const STATUS_LABEL: Record<LoyaltyMemberStatus, string> = {
  active: 'Active',
  inactive: 'Inactive',
}

// TODO(loyalty): the mockup includes an "Expiring Soon" status (amber dot).
// LoyaltyMemberStatus only models 'active' | 'inactive'. Uncomment the
// branch + map entries below when the backend adds an "expiring" status
// (derived from loyaltyLastActivity + expiry_warning).
// const EXPIRING_COLOR = p.amber[700]
// const EXPIRING_LABEL = 'Expiring Soon'

export const StatusDot: React.FC<StatusDotProps> = ({ status }) => {
  if (!status) {
    return <span style={{ fontSize: 12, color: p.gray[400] }}>—</span>
  }

  const color = STATUS_COLOR[status]
  const label = STATUS_LABEL[status]

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 12,
        fontWeight: 500,
        color: p.gray[700],
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: color,
        }}
      />
      {label}
    </span>
  )
}
